import { useMutation } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import type { IHttpService } from '../services/http/http.service';
import { HttpService } from '../services/http/http.service';
import { useAnalytics } from './analytics/use-analytics';

interface AcceptInviteResult {
  tenantId: string;
  tenantName: string;
  roleName: string;
}

export function useAcceptInvite() {
  const http = useInjection<IHttpService>(HttpService);
  const { trackEvent } = useAnalytics();

  return useMutation({
    mutationFn: ({ token, tenantId }: { token: string; tenantId: string }) =>
      http.post<AcceptInviteResult>(
        `invite/${encodeURIComponent(token)}/accept?tenantId=${encodeURIComponent(tenantId)}`,
      ),
    onSuccess: () => {
      trackEvent('team_invite_accept', {});
    },
  });
}
